import {NeoButton} from "@/components/forms";
import {NeoHeader} from "@/components/shared";
import {Image, Progress} from "@nextui-org/react";
import {useState} from "react";
import {RoutePlanBillingHistory} from "./billingHistory";
//RoutePlanBillingHistory
export const CreditUsageOverview = () => {
  const [showBillingHistory, setShowBillingHistory] = useState(false);
  return (
    <div className="flex min-h-[calc(100vh-63px)] bg-gray-100 px-5 py-5">
      <div className="flex w-full flex-col gap-2 ">
        <div className="mb-4 flex flex-col items-start">
          <NeoHeader message="Credits Usage Overview"></NeoHeader>
          <p className="text-xs font-semibold text-gray-400">
            Track and optimize your credit usage
          </p>
        </div>
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 space-y-2 md:col-span-8">
            <div className="flex flex-col gap-2">
              {/* Header boxes  */}
              <div className="grid grid-cols-3 gap-2">
                {/* Box 1 */}
                <div className="flex flex-col gap-4 rounded-lg bg-white p-4 shadow">
                  <div className="flex items-center justify-between">
                    Total Credits
                    <div className="flex items-center gap-1 rounded bg-yellow-100 p-2 px-2">
                      <Image
                        className="h-8 w-8"
                        src="/icons/routePlan/totalCredit.svg"
                        alt="filter"
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-between gap-6">
                    <div className="flex flex-col">
                      <p className="text-xl font-bold">1200</p>
                      <p className="text-sm text-gray-400">Credits</p>
                    </div>
                    <div className="flex w-full">
                      <Progress
                        classNames={{
                          label: "flex justify-between w-full", // spread them
                          value: "ml-2" // small spacing if needed
                        }}
                        color="warning"
                        //  formatOptions={{style: "currency", currency: "ARS"}}
                        label="428/1000"
                        maxValue={1000}
                        showValueLabel={true}
                        size="sm"
                        value={428}
                      />
                    </div>
                  </div>
                </div>
                {/* Box 2 */}
                <div className="flex flex-col gap-4 rounded-lg bg-white p-4 shadow">
                  <div className="flex items-center justify-between">
                    Used in this Month
                    <div className="flex items-center gap-1 rounded bg-yellow-100 p-2 px-2">
                      <Image
                        className="h-8 w-8"
                        src="/icons/routePlan/usageChart.svg"
                        alt="filter"
                      />
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <div className="flex flex-col">
                      <p className="text-xl font-bold">1200</p>
                      <p className="text-sm text-gray-400">Credits</p>
                    </div>
                  </div>
                </div>
                {/* Box 3 */}
                <div className="flex flex-col gap-4 rounded-lg bg-white p-4 shadow">
                  <div className="flex items-center justify-between">
                    Remaing
                    <div className="flex items-center gap-1 rounded bg-yellow-100 p-2 px-2">
                      <Image
                        className="h-8 w-8"
                        src="/icons/routePlan/remaining.svg"
                        alt="filter"
                      />
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <div className="flex flex-col">
                      <p className="text-xl font-bold">1200</p>
                      <p className="text-sm text-gray-400">Credits</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Activity Log */}
              <div className="bg-white p-4">
                <div className="mb-4 flex items-center justify-between">
                  <p className="font-bold">Activity Log</p>
                </div>
                <div className="flex flex-col gap-2">
                  {/* log 1 */}
                  <div className="flex items-center justify-between bg-gray-100 p-2">
                    <div className="flex items-center gap-4">
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9528_27315)">
                          <path
                            d="M18 3.625C18 5.38984 15.9223 8.02305 15.0258 9.07422C14.8922 9.22891 14.6953 9.28867 14.516 9.25H11.25C10.6277 9.25 10.125 9.75273 10.125 10.375C10.125 10.9973 10.6277 11.5 11.25 11.5H14.625C16.4883 11.5 18 13.0117 18 14.875C18 16.7383 16.4883 18.25 14.625 18.25H4.90781C5.21367 17.902 5.58633 17.4555 5.9625 16.9563C6.18398 16.6609 6.4125 16.3375 6.63047 16H14.625C15.2473 16 15.75 15.4973 15.75 14.875C15.75 14.2527 15.2473 13.75 14.625 13.75H11.25C9.38672 13.75 7.875 12.2383 7.875 10.375C7.875 8.51172 9.38672 7 11.25 7H12.6492C11.9109 5.89258 11.25 4.61992 11.25 3.625C11.25 1.76172 12.7617 0.25 14.625 0.25C16.4883 0.25 18 1.76172 18 3.625ZM4.1168 17.4449C3.9832 17.5961 3.86367 17.7297 3.76172 17.8422L3.69844 17.9125L3.69141 17.9055C3.48047 18.0672 3.17812 18.0461 2.98828 17.8422C2.10234 16.8789 0 14.4004 0 12.625C0 10.7617 1.51172 9.25 3.375 9.25C5.23828 9.25 6.75 10.7617 6.75 12.625C6.75 13.6797 6.0082 14.9805 5.2207 16.0668C4.84453 16.5836 4.45781 17.0512 4.13789 17.4203L4.1168 17.4449ZM4.5 12.625C4.5 12.3266 4.38147 12.0405 4.1705 11.8295C3.95952 11.6185 3.67337 11.5 3.375 11.5C3.07663 11.5 2.79048 11.6185 2.5795 11.8295C2.36853 12.0405 2.25 12.3266 2.25 12.625C2.25 12.9234 2.36853 13.2095 2.5795 13.4205C2.79048 13.6315 3.07663 13.75 3.375 13.75C3.67337 13.75 3.95952 13.6315 4.1705 13.4205C4.38147 13.2095 4.5 12.9234 4.5 12.625ZM14.625 4.75C14.9234 4.75 15.2095 4.63147 15.4205 4.4205C15.6315 4.20952 15.75 3.92337 15.75 3.625C15.75 3.32663 15.6315 3.04048 15.4205 2.8295C15.2095 2.61853 14.9234 2.5 14.625 2.5C14.3266 2.5 14.0405 2.61853 13.8295 2.8295C13.6185 3.04048 13.5 3.32663 13.5 3.625C13.5 3.92337 13.6185 4.20952 13.8295 4.4205C14.0405 4.63147 14.3266 4.75 14.625 4.75Z"
                            fill="#FFC727"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9528_27315">
                            <path d="M0 0.25H18V18.25H0V0.25Z" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <div className="flex flex-col justify-center">
                        <p className="text-sm font-bold">Route Plan</p>
                        <p className="text-xs text-gray-400">
                          Optimized route for Bus #23 with 15 stops
                        </p>
                        <p className="text-xs text-gray-400">
                          Today, 2:30 PM • John Doe
                        </p>
                      </div>
                    </div>
                    <div className="rounded-lg bg-yellow-200 px-4 ">
                      <p className="text-sm font-bold text-yellow-500">
                        -5 Cedits
                      </p>
                    </div>
                  </div>
                  {/* log 2 */}
                  <div className="flex items-center justify-between bg-gray-100 p-2">
                    <div className="flex items-center gap-4">
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9528_27315)">
                          <path
                            d="M18 3.625C18 5.38984 15.9223 8.02305 15.0258 9.07422C14.8922 9.22891 14.6953 9.28867 14.516 9.25H11.25C10.6277 9.25 10.125 9.75273 10.125 10.375C10.125 10.9973 10.6277 11.5 11.25 11.5H14.625C16.4883 11.5 18 13.0117 18 14.875C18 16.7383 16.4883 18.25 14.625 18.25H4.90781C5.21367 17.902 5.58633 17.4555 5.9625 16.9563C6.18398 16.6609 6.4125 16.3375 6.63047 16H14.625C15.2473 16 15.75 15.4973 15.75 14.875C15.75 14.2527 15.2473 13.75 14.625 13.75H11.25C9.38672 13.75 7.875 12.2383 7.875 10.375C7.875 8.51172 9.38672 7 11.25 7H12.6492C11.9109 5.89258 11.25 4.61992 11.25 3.625C11.25 1.76172 12.7617 0.25 14.625 0.25C16.4883 0.25 18 1.76172 18 3.625ZM4.1168 17.4449C3.9832 17.5961 3.86367 17.7297 3.76172 17.8422L3.69844 17.9125L3.69141 17.9055C3.48047 18.0672 3.17812 18.0461 2.98828 17.8422C2.10234 16.8789 0 14.4004 0 12.625C0 10.7617 1.51172 9.25 3.375 9.25C5.23828 9.25 6.75 10.7617 6.75 12.625C6.75 13.6797 6.0082 14.9805 5.2207 16.0668C4.84453 16.5836 4.45781 17.0512 4.13789 17.4203L4.1168 17.4449ZM4.5 12.625C4.5 12.3266 4.38147 12.0405 4.1705 11.8295C3.95952 11.6185 3.67337 11.5 3.375 11.5C3.07663 11.5 2.79048 11.6185 2.5795 11.8295C2.36853 12.0405 2.25 12.3266 2.25 12.625C2.25 12.9234 2.36853 13.2095 2.5795 13.4205C2.79048 13.6315 3.07663 13.75 3.375 13.75C3.67337 13.75 3.95952 13.6315 4.1705 13.4205C4.38147 13.2095 4.5 12.9234 4.5 12.625ZM14.625 4.75C14.9234 4.75 15.2095 4.63147 15.4205 4.4205C15.6315 4.20952 15.75 3.92337 15.75 3.625C15.75 3.32663 15.6315 3.04048 15.4205 2.8295C15.2095 2.61853 14.9234 2.5 14.625 2.5C14.3266 2.5 14.0405 2.61853 13.8295 2.8295C13.6185 3.04048 13.5 3.32663 13.5 3.625C13.5 3.92337 13.6185 4.20952 13.8295 4.4205C14.0405 4.63147 14.3266 4.75 14.625 4.75Z"
                            fill="#FFC727"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9528_27315">
                            <path d="M0 0.25H18V18.25H0V0.25Z" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <div className="flex flex-col justify-center">
                        <p className="text-sm font-bold">Route Plan</p>
                        <p className="text-xs text-gray-400">
                          Optimized route for Bus #23 with 15 stops
                        </p>
                        <p className="text-xs text-gray-400">
                          Today, 2:30 PM • John Doe
                        </p>
                      </div>
                    </div>
                    <div className="rounded-lg bg-yellow-200 px-4 ">
                      <p className="text-sm font-bold text-yellow-500">
                        -5 Cedits
                      </p>
                    </div>
                  </div>
                  {/* log 3 */}
                  <div className="flex items-center justify-between bg-gray-100 p-2">
                    <div className="flex items-center gap-4">
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9528_27315)">
                          <path
                            d="M18 3.625C18 5.38984 15.9223 8.02305 15.0258 9.07422C14.8922 9.22891 14.6953 9.28867 14.516 9.25H11.25C10.6277 9.25 10.125 9.75273 10.125 10.375C10.125 10.9973 10.6277 11.5 11.25 11.5H14.625C16.4883 11.5 18 13.0117 18 14.875C18 16.7383 16.4883 18.25 14.625 18.25H4.90781C5.21367 17.902 5.58633 17.4555 5.9625 16.9563C6.18398 16.6609 6.4125 16.3375 6.63047 16H14.625C15.2473 16 15.75 15.4973 15.75 14.875C15.75 14.2527 15.2473 13.75 14.625 13.75H11.25C9.38672 13.75 7.875 12.2383 7.875 10.375C7.875 8.51172 9.38672 7 11.25 7H12.6492C11.9109 5.89258 11.25 4.61992 11.25 3.625C11.25 1.76172 12.7617 0.25 14.625 0.25C16.4883 0.25 18 1.76172 18 3.625ZM4.1168 17.4449C3.9832 17.5961 3.86367 17.7297 3.76172 17.8422L3.69844 17.9125L3.69141 17.9055C3.48047 18.0672 3.17812 18.0461 2.98828 17.8422C2.10234 16.8789 0 14.4004 0 12.625C0 10.7617 1.51172 9.25 3.375 9.25C5.23828 9.25 6.75 10.7617 6.75 12.625C6.75 13.6797 6.0082 14.9805 5.2207 16.0668C4.84453 16.5836 4.45781 17.0512 4.13789 17.4203L4.1168 17.4449ZM4.5 12.625C4.5 12.3266 4.38147 12.0405 4.1705 11.8295C3.95952 11.6185 3.67337 11.5 3.375 11.5C3.07663 11.5 2.79048 11.6185 2.5795 11.8295C2.36853 12.0405 2.25 12.3266 2.25 12.625C2.25 12.9234 2.36853 13.2095 2.5795 13.4205C2.79048 13.6315 3.07663 13.75 3.375 13.75C3.67337 13.75 3.95952 13.6315 4.1705 13.4205C4.38147 13.2095 4.5 12.9234 4.5 12.625ZM14.625 4.75C14.9234 4.75 15.2095 4.63147 15.4205 4.4205C15.6315 4.20952 15.75 3.92337 15.75 3.625C15.75 3.32663 15.6315 3.04048 15.4205 2.8295C15.2095 2.61853 14.9234 2.5 14.625 2.5C14.3266 2.5 14.0405 2.61853 13.8295 2.8295C13.6185 3.04048 13.5 3.32663 13.5 3.625C13.5 3.92337 13.6185 4.20952 13.8295 4.4205C14.0405 4.63147 14.3266 4.75 14.625 4.75Z"
                            fill="#FFC727"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9528_27315">
                            <path d="M0 0.25H18V18.25H0V0.25Z" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <div className="flex flex-col justify-center">
                        <p className="text-sm font-bold">Route Plan</p>
                        <p className="text-xs text-gray-400">
                          Optimized route for Bus #23 with 15 stops
                        </p>
                        <p className="text-xs text-gray-400">
                          Today, 2:30 PM • John Doe
                        </p>
                      </div>
                    </div>
                    <div className="rounded-lg bg-yellow-200 px-4 ">
                      <p className="text-sm font-bold text-yellow-500">
                        -5 Cedits
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-12 p-1 md:col-span-4">
            <div className="flex flex-col gap-5">
              {/* Quick action box */}
              <div className="flex flex-col gap-4 bg-white p-4">
                <p className="font-lg font-bold">Quick Actions</p>

                <NeoButton
                  type="button"
                  color="black"
                  size="sm"
                  className="gap-[5px] text-sm"
                  startContent={
                    <Image
                      className="h-5 w-5"
                      src="/icons/routePlan/routePlancoin.svg"
                      alt="filter"
                    />
                  }
                >
                  Get Credits
                </NeoButton>

                <NeoButton
                  type="button"
                  size="sm"
                  color="default"
                  className="gap-[5px] text-sm"
                  onClick={() => setShowBillingHistory(true)}
                  startContent={
                    <Image
                      className="h-5 w-5"
                      src="/icons/routePlan/history.svg"
                      alt="filter"
                    />
                  }
                >
                  View Billing History
                </NeoButton>
              </div>
              {/* Usage Break down */}
              <div className="flex flex-col gap-4 bg-white p-4">
                <p className="font-lg font-bold">Usage Breakdown</p>
                <div className="flex items-center justify-between gap-20">
                  {/* <div className="flex items-center gap-1">
                    <span className="rounded-full bg-yellow-500 p-2"> </span>
                    <p className="text-sm font-light">Route Plan</p>
                  </div> */}
                  <Progress
                    classNames={{
                      label: "flex justify-between w-full", // spread them
                      value: "ml-2" // small spacing if needed
                    }}
                    color="warning"
                    //  formatOptions={{style: "currency", currency: "ARS"}}
                    label="Route Plan"
                    maxValue={1000}
                    showValueLabel={true}
                    size="sm"
                    value={428}
                  />
                </div>
                <div className="flex items-center justify-between">
                  {/* <div className="flex items-center gap-1">
                    <span className="rounded-full bg-blue-500 p-2"> </span>
                    <p className="text-sm font-light">Vahan Fetch</p>
                  </div>
                  % */}
                  <Progress
                    classNames={{
                      label: "flex justify-between w-full", // spread them
                      value: "ml-2" // small spacing if needed
                    }}
                    color="primary"
                    //  formatOptions={{style: "currency", currency: "ARS"}}
                    label="Vahan Fetch"
                    maxValue={1000}
                    showValueLabel={true}
                    size="sm"
                    value={428}
                  />
                </div>
              </div>
              {/* Usage Trends*/}
              <div className="flex flex-col gap-4 bg-white p-4">
                <p className="font-lg font-bold">Usage Trends</p>
                <div className="flex flex-col gap-4">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-light">This Month</p>
                    <p className="text-sm font-bold">428 Credits</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-light">Last Month</p>
                    <p className="text-sm font-bold">512 Credits</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-light">This Year</p>
                    <p className="text-sm font-bold">5,120 Credits</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RoutePlanBillingHistory
        showBillingHistory={showBillingHistory}
        setShowBillingHistory={setShowBillingHistory}
      />
    </div>
  );
};
